import { render } from "./LaUltimaView.vue?vue&type=template&id=12bf03b2"
import script from "./LaUltimaView.vue?vue&type=script&lang=js"
export * from "./LaUltimaView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__